/**
 * parse bih number with comma and return string
 * @param {number} number - parsed number
 * @returns {string} parsed string
 */
export const parseBigNumber = (number: number): string => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
